import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetSociogram = sociogramId => {
  const query = useApiQuery(
    ['sociogramById', sociogramId],
    'sociogram',
    `/sociograms?id=${sociogramId}`,
    { enabled: !!sociogramId }
  )

  return {
    isLoadingSociogram: query.isLoading || query.isFetching,
    dataSociogram: query.data ?? null,
    errorSociogram: query.isError ? query.error : null,
    getSociogram: query.refetch
  }
}
